// extracted by mini-css-extract-plugin
export default {"root":"UserMenuMainInfo_root__4XUHo","name":"UserMenuMainInfo_name__yE7D+","email":"UserMenuMainInfo_email__imZjh","content":"UserMenuMainInfo_content__e9csI"};